module.exports = __webpack_public_path__ + "img/confetti.8d7a8ba.svg";